/* eslint-disable max-len */
import React from 'react'
import TopHeader from '../TopHeader'
import { Link } from 'react-router-dom'
export default function Emptyscreen({FirstPTag,SecondePTag,title,isPatientTemplate,isPatientDeviceTemplate,PatientNotes,OrgMonitorheight,monitorPatientList,organizationUser}) {
    return (
        <>
            <TopHeader title={title}/>
           
            <div className={`bg-white rounded-lg py-3 px-6 ${isPatientTemplate !== undefined || isPatientDeviceTemplate !== undefined? 'h-[calc(100vh-450px)]': PatientNotes? 'h-auto' : OrgMonitorheight? 'h-[calc(100vh-207px)]': monitorPatientList ? 'h-[calc(100vh-312px)]' : organizationUser? 'h-[calc(100vh-254px)]' : 'h-customh7'}
                flex flex-col justify-center items-center`}>
                <img src="/images/emptyscreen_img.png" alt="emptyscreen" className="mx-auto" loading='lazy' decoding='async'/>
                <p id= "empty_screen" className="text-center text-xl font-normsl text-[#000]">{FirstPTag} <br />{SecondePTag}</p>
                {(isPatientTemplate!==undefined||isPatientDeviceTemplate!==undefined)&&<Link to={isPatientDeviceTemplate!==undefined?'/manage-devices/add-device':'/manage-monitoring-condition-templates/add-template'} className='mt-5'>
                    <button type='button'
                        id="Add user"
                        className={`py-2.5 px-4 flex items-center text-lg font-normal text-[#fff] rounded-[16px] ml-2.5 
        bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88] 2xl:w-[197px] 2xl:mb-0 mb-2.5`} style={{'width':'max-content'}}>
                        <span className="mr-2.5"><img src="/images/add_Icon_white.svg" alt="img" /></span>
                        <span>{isPatientDeviceTemplate!==undefined?'Add Device':'Create Template'}</span> 
                    </button>
                </Link>}
            </div>
           
        </>

       
    )
}
